import { render, staticRenderFns } from "./company-case-add.vue?vue&type=template&id=f0a6158e&scoped=true"
import script from "./company-case-add.vue?vue&type=script&lang=js"
export * from "./company-case-add.vue?vue&type=script&lang=js"
import style0 from "./company-case-add.vue?vue&type=style&index=0&id=f0a6158e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a6158e",
  null
  
)

export default component.exports